import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const ProtectedRoute = ({ redirectPath = '/', children,}) => {
  const auth = useAuth();
 
  if ( auth.isAuthenticated() ) {
	return  children ? children : <Outlet />;
  }
  
  return <Navigate to={redirectPath} replace />;

  
};

export default ProtectedRoute;